// updates the URL hash with parameters separated by '&'

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import {useRoute} from "vue-router";

export function useUrlHash() {
  const route = useRoute(); // this gets run in the parent
  function setUrlHash(...parameters) {
    // silently update url without triggering vue router
    // https://stackoverflow.com/q/51337255/
    parameters = parameters.filter(Boolean);
    const parameterString = parameters.join("&");
    log(`useUrlHash(${parameterString})`);
    if (parameterString) {
      history.replaceState({}, null, `${route.path}#${parameterString}`);
    } else {
      history.replaceState({}, null, `${route.path}`); // empty hash
    }
  }
  return {setUrlHash};
}
